// src
import { MY_PLANNING_ID, PresetType, FETCHABLE_RESOURCES, ResourceType } from "config/constants";

export const updateEvents = ({ byPreset }, enableds) => {
  const events = [];
  const enabledIds = enableds.map(({ id }) => id);
  const isEnabled = ([id]) => enabledIds.includes(id);
  const enabledPresetLots = Object.entries(byPreset).filter(isEnabled);

  enabledPresetLots.forEach(([id, presetLot]) => {
    const { byDay } = presetLot;
    const preset = enableds.find(({ id: presetId }) => presetId === id);
    const stacked = preset.options && preset.options.stack;
    Object.entries(byDay).forEach(([, dayLot]) => {
      dayLot.events.forEach((e) =>
        // stacked events will belong to the preset row in timeline mode, not to attached resources
        events.push({ ...e, presetId: id, ...(stacked && { stacked }) }),
      );
    });
  });
  return events;
};

const sortRows = ({ id: id1 }, { id: id2 }) => (id1 < id2 ? -1 : 1);

export const updateRows = (enableds) => {
  // rows ARE resources OR full presets with stack option = true.
  // Enclosing/nesting rows are processed live from these ones in the timeline container
  // Caution:
  // - rows id have to be unique accross resources (ensure through OPID?)
  //   (specifying a string id like room-635 does not seem to work)
  // - resourceType are defined on presets and on timeline rows, a preset may create several rows
  const map = new Map();
  enableds.forEach(({ id, name, params, options, resourceType, type: presetType }) => {
    if (id === MY_PLANNING_ID) {
      map.set(id, { id, name, resourceType });
    } else if (presetType === PresetType.PERMANENT && options && options.stack) {
      map.set(id, { id, name, presetType, resourceType });
    } else if (presetType === PresetType.INSTANT) {
      map.set(id, { id, name, presetType, resourceType });
    } else if (params) {
      // ---> preset of type Resource or Permanent not stacked <---
      for (const { type: t, singular, plural } of FETCHABLE_RESOURCES) {
        if (params[plural]) {
          params[plural].forEach((resourceId) => {
            map.set(`${singular}-${resourceId}`, { id: resourceId, resourceType: t });
          });
          break;
        }
      }
      // people are not part/different from FETCHABLE_RESOURCES
      if (params.people) {
        params.people.forEach((resourceId) => {
          map.set(`person-${resourceId}`, { id: resourceId, resourceType: ResourceType.PERSON });
        });
      }
    }
  });
  return Array.from(map.values()).sort(sortRows);
};
